import { isChunkLoadError, recoverFromChunkLoadError } from "~/utils/chunkLoadRecovery";
import { handleError } from "~/utils/handleError";

export const errorHandler = {
  install(app) {
    app.config.globalProperties.$errorHandler = {
      handleError,
    };
    app.config.errorHandler = function (error) {
      if (isChunkLoadError(error)) {
        recoverFromChunkLoadError();
      }
    };
  },
};
